import { useAppSelector } from 'app/redux/store';
import { AppSettings } from 'core/AppSettings';
import { useEffect } from 'react';
import { sha256Hex } from './sha256Hex';
import { LogManager } from 'core/logging/LogManager';

const PRODUCT_NAME = 'EnvirosuiteOmnis';

const logger = LogManager.getLogger('useGainsightIdentifyUser');

export const useGainsightIdentifyUser = () => {
  const { details } = useAppSelector(state => state.profile.user);
  const {
    facility: { facilityAlias, salesForceAccountId },
  } = useAppSelector(state => state.profile);
  useEffect(() => {
    const aptrinsic = window.aptrinsic;
    if (typeof aptrinsic !== 'function') return;
    if (!details || !facilityAlias) return;
    const { id, email } = details;
    const run = async () => {
      // The documentation recommends the id for identify must be the hashed user email and fallback to the product name with user's unique id
      // See: https://ideagen.atlassian.net/wiki/spaces/ICSA/pages/39129449495/Gainsight+PX#Identification-Fields
      const normalizedEmail = email ? email.trim().toLowerCase() : undefined;
      const gainsightUserId = normalizedEmail ? await sha256Hex(normalizedEmail) : `${PRODUCT_NAME}-${id}`;
      const account = salesForceAccountId
        ? {
            id: salesForceAccountId,
            name: facilityAlias,
            parentGroupId: salesForceAccountId,
            sfdcId: salesForceAccountId,
          }
        : { id: `${PRODUCT_NAME}-${facilityAlias}`, name: facilityAlias };

      logger.debug('Identifying user to Gainsight', { gainsightUserId, account });

      aptrinsic(
        'identify',
        { id: gainsightUserId, email: normalizedEmail, appversion: AppSettings.releaseNumber },
        account
      );
    };
    run();
  }, [details, facilityAlias, salesForceAccountId]);
};
